<ng-template #modalConfirmDelete let-c="close" let-d="dismiss">
  <wsb-modal [cancelButtonEnable]="true" title="{{ '' | translate }}" (dismiss)="d()" (primary)="closeDelete()" text="{{ '' | translate }}">
    <div body>
      <span>{{ 'sms_remove_confirm_text' | translate }}</span>
    </div>
  </wsb-modal>
</ng-template>
<ng-template #modalConfirmEdit let-c="close" let-d="dismiss">
  <wsb-modal [cancelButtonEnable]="true" title="{{ '' | translate }}" (dismiss)="d()" (primary)="closeEdit()" text="{{ '' | translate }}">
    <div body>
      <span innerHtml="{{ 'sms_editscheduled_confirm_text' | translate }}"></span>
    </div>
  </wsb-modal>
</ng-template>
  <div class="my-3 mb-5">
    <wsb-atlas-grid
      #grid
      class="atlas-grid-simplest"
      class="mt-2"
      *ngIf="tableColumnsDefs && tableHistoryGridOptions"
      [loading]="tableLoading"
      [columnDefs]="tableColumnsDefs"
      [checkboxDisable]="true"
      [options]="tableHistoryGridOptions"
      [components]="components"
      [@gridIsLoaded]="gridAnimationState"
    ></wsb-atlas-grid>
  </div>
